import React from "react";

const Button = ({ title = "Click Me!", extra = "", onClick, id }) => {
    return (
        <p id={id} className={`this-button ${extra}`} onClick={onClick}>
            {title}
        </p>
    );
};

export default Button;
